const replaceCommaIfString = (o:number, v:string): number => {
  if (typeof (v) === 'string') {
    return parseFloat(v ? v.replace(/,/g, '') : '0');
  }
  return v;
};

export default replaceCommaIfString;
